(function () {
    var root = document.getElementById('cc-root');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(pointer: fine)').matches;
    root.dataset.pointer = fine ? 'fine' : 'coarse';

    if (fine && !reduce) {
      var glow = root.querySelector('.cc__glow');
      var gx = window.innerWidth / 2, gy = window.innerHeight / 2;
      var cx = gx, cy = gy, raf = null;

      var tick = function () {
        cx += (gx - cx) * 0.12;
        cy += (gy - cy) * 0.12;
        if (glow) glow.style.translate = cx + 'px ' + cy + 'px';
        if (Math.abs(gx - cx) > 0.4 || Math.abs(gy - cy) > 0.4) {
          raf = requestAnimationFrame(tick);
        } else {
          raf = null;
        }
      };

      window.addEventListener('pointermove', function (e) {
        gx = e.clientX; gy = e.clientY;
        if (!raf) raf = requestAnimationFrame(tick);
      }, { passive: true });
    }

    root.querySelectorAll('[data-glow]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--px', ((e.clientX - r.left) / r.width * 100) + '%');
        el.style.setProperty('--py', ((e.clientY - r.top) / r.height * 100) + '%');
      }, { passive: true });
    });

    if (!reduce) {
      root.querySelectorAll('[data-tilt]').forEach(function (el) {
        var stage = el.parentElement;
        var max = 15;

        stage.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          var rx = (0.5 - py) * max * 2;
          var ry = (px - 0.5) * max * 2;
          el.style.transition = 'transform .12s linear';
          el.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.03)';
          el.style.setProperty('--fx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--fy', (py * 100).toFixed(1) + '%');
        }, { passive: true });

        stage.addEventListener('pointerleave', function () {
          el.style.transition = 'transform .7s cubic-bezier(.22,.61,.36,1)';
          el.style.transform = '';
          el.style.setProperty('--fx', '50%');
          el.style.setProperty('--fy', '50%');
        });
      });
    }

    if (fine && !reduce) {
      root.querySelectorAll('[data-magnet]').forEach(function (el) {
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) * 0.22;
          var dy = (e.clientY - (r.top + r.height / 2)) * 0.3;
          el.style.transform = 'translate3d(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px,0)';
        }, { passive: true });
        el.addEventListener('pointerleave', function () {
          el.style.transform = '';
        });
      });
    }

    var targets = root.querySelectorAll('[data-reveal]');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
    }

    var nav = document.getElementById('cc-nav');
    if (nav) {
      var onScroll = function () {
        nav.dataset.stuck = window.scrollY > 40 ? 'true' : 'false';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var burger = document.getElementById('cc-burger');
    var mobile = document.getElementById('cc-mobile');
    var mclose = document.getElementById('cc-mobile-close');
    var setMobile = function (open) {
      if (!mobile) return;
      mobile.dataset.open = open ? 'true' : 'false';
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    if (burger) burger.addEventListener('click', function () { setMobile(true); });
    if (mclose) mclose.addEventListener('click', function () { setMobile(false); });
    if (mobile) {
      mobile.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { setMobile(false); });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMobile(false);
    });

    var countEl = document.getElementById('cc-count');
    if (countEl) {
      var target = new Date(countEl.dataset.target).getTime();
      var cells = {
        d: countEl.querySelector('[data-unit="d"]'),
        h: countEl.querySelector('[data-unit="h"]'),
        m: countEl.querySelector('[data-unit="m"]'),
        s: countEl.querySelector('[data-unit="s"]')
      };
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      var render = function () {
        if (isNaN(target)) return;
        var diff = target - Date.now();
        if (diff <= 0) {
          countEl.innerHTML = '<div class="cc__countCell" style="min-width:auto;padding:16px 26px"><div class="cc__countNum cc__holotext">Es ist soweit</div></div>';
          return;
        }
        var sec = Math.floor(diff / 1000);
        cells.d.textContent = Math.floor(sec / 86400);
        cells.h.textContent = pad(Math.floor(sec % 86400 / 3600));
        cells.m.textContent = pad(Math.floor(sec % 3600 / 60));
        cells.s.textContent = pad(sec % 60);
      };
      render();
      setInterval(render, 1000);
    }

    var drop = document.getElementById('cc-drop');
    if (drop) {
      if (reduce) {
        drop.remove();
      } else {
        var fired = false;
        var events = ['scroll', 'wheel', 'touchmove', 'keydown'];
        var fire = function () {
          if (fired) return;
          fired = true;
          drop.dataset.active = 'true';
          events.forEach(function (ev) { window.removeEventListener(ev, fire); });
          var cards = drop.querySelectorAll('.cc__dropCard');
          var last = cards[cards.length - 1];
          if (last) {
            last.addEventListener('animationend', function () {
              if (drop.parentNode) drop.remove();
            });
          }
          setTimeout(function () { if (drop.parentNode) drop.remove(); }, 8000);
        };
        events.forEach(function (ev) { window.addEventListener(ev, fire, { passive: true }); });
      }
    }

    var reel = document.getElementById('cc-reel');
    var reelBtn = document.getElementById('cc-reel-sound');
    if (reel && reelBtn) {
      reelBtn.addEventListener('click', function () {
        reel.muted = !reel.muted;
        reelBtn.setAttribute('aria-pressed', reel.muted ? 'false' : 'true');
        var lab = reelBtn.querySelector('.cc__reelSoundLabel');
        if (lab) lab.textContent = reel.muted ? 'Ton an' : 'Ton aus';
        if (!reel.muted) reel.play();
      });
    }

    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (!id || id === '#') return;
        var t = document.querySelector(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  })();
